import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import TenderedProjectCard from "./projectCard/TenderedProjectCard";
import { TenderedProjectDto } from "../../types/projectTypes";
import { AddCircle } from "@mui/icons-material";
import useResponsive from "../../hooks/useResponsive";
import { Link } from "react-router-dom";

interface ProjectTendersProps {
  tenderedProjects: TenderedProjectDto[];
}

/**
 * Component to display all tendered projects in a grid.
 */
const ProjectTenders = ({ tenderedProjects }: ProjectTendersProps) => {
  const isMobile = useResponsive("down", "sm");

  return (
    <>
      <Button variant="outlined" color={"info"} startIcon={<AddCircle />} sx={{ height: 40, marginBottom: 4 }}>
        <Link to="/leads/anlegen" style={{ textDecoration: "none", color: "inherit" }}>
          <Typography fontSize={isMobile ? 12 : 14}>Neuen Lead anlegen</Typography>
        </Link>
      </Button>
      <Grid container rowSpacing={5}>
        {tenderedProjects.map((project) => (
          <Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={project.projectId}>
            <TenderedProjectCard {...project} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ProjectTenders;
